import React from 'react';
import Status from 'components/status';
import { getNewPublishableVersion } from 'utils/app';

export default function AppReviewStatus({ app, blank = false }) {
  const { staged_props } = app;

  const newPublishableVersion = getNewPublishableVersion(app);

  if (!staged_props?.version && !newPublishableVersion) {
    return null;
  }

  return (
    <Status type={staged_props?.version ? 'warning' : 'primary'} blank={blank}>
      {staged_props?.version ? `Staged release` : 'New release'}
    </Status>
  );
}
